import { FC } from 'react';
import Typography from 'components/commercetools-ui/atoms/typography';
import { ContentSliderSlideProps } from '../../content-slider';
import Link from 'components/commercetools-ui/atoms/link';
import Button from 'components/commercetools-ui/atoms/button';
import { Reference } from 'types/reference';
import Image from 'frontastic/lib/image';

type CtaButtonType = {
  href: string | Reference | undefined;
  title: string | undefined;
};

const CTATile: FC<ContentSliderSlideProps> = ({ image, card_title, ctas, card_description, tag_line }) => {
  return (
    <div className="w-full relative overflow-hidden xl:min-h-[30rem] 2xl:min-h-[48rem]">
      {image && (
        <div className="relative h-[20rem] md:h-[24rem] 2xl:h-[35rem]">
          <div className="absolute z-10 h-auto w-full bg-black opacity-20"></div>
          <Image src={image?.url} alt={card_title} className="object-cover w-full h-full" loading='lazy' height={500} width={500}/>
        </div>
      )}
      {tag_line && (
        <Typography className="text-16 2xl:text-16 middleresolution:text-14 xl:text-12 font-normal middleresolution:pt-16 xl:pt-8 pt-24 2xl:pt-24 leading-6 text-[#333]">
          {tag_line}
        </Typography>
      )}
      {card_title && (
        <Typography as="h4" className="2xl:pt-16 xl:pt-4 middleresolution:pt-8 pt-16 2xl:text-22 xl:text-18 text-22 text-[#333] font-medium leading-8">
          {card_title}
        </Typography>
      )}
      {card_description && (
        <Typography className="text-16 2xl:min-h-[1rem] xlg:min-h-[3.75rem] xl:text-14 2xl:text-16 font-normal 2xl:pt-8 xl:pt-4 pt-8 leading-6 text-[#333]">
          {card_description}
        </Typography>
      )}
      <div className="flex gap-10 2xl:pt-16 xl:pt-4 middleresolution:pt-8 pt-16 flex-col md:flex-row">
        {ctas?.length > 0 &&
          ctas.map((ctaButton: any, index: number) => (
              <Link link={ctaButton?.button?.href} key={index} target="_blank">
                <Button
                  className={
                    index === 0
                      ? 'border-1 z-10 rounded-none border border-[#2B2C39] bg-white shadow-sm hover:!bg-[#F4F4F4] hover:!border-[#F4F4F4] px-18 py-10 md:px-32 md:py-18 w-full md:w-fit'
                      : 'border-1 z-10 rounded-none border border-[#2B2C39] bg-[#2B2C39] shadow-sm hover:!bg-[#394A54] px-18 py-10 md:px-32 md:py-18 w-full md:w-fit'
                  }
                >
                  <Typography
                    as="span"
                    className={`2xl:text-16 xl:text-14 text-16 ${index === 0 ? 'text-[#090909]' : 'text-white'}`}
                  >
                    {ctaButton?.button?.title}
                  </Typography>
                </Button>
              </Link>
          ))}
      </div>
    </div>
  );
};

export default CTATile;